import React from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { NoAvailableMessageContent } from 'app/shared/components/common/NoAvailableMessage';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { ArrowCheckIcon } from '../icons';
import LabelCDS from '../LabelCDS';
import SecondaryTabGroupCDS from '../SecondaryTabGroupCDS';

const AccordionCDS = ({
  isLoading,
  title = '',
  labelProps,
  children,
  customStyles,
  additionalSummaryContent,
  pendingChangesLabelProps,
  pendingChangesToggleButtonProps,
  className = 'p-24',
  arrowSize = 24,
  titleVariant = 'bold20',
  defaultExpanded = false,
  expanded,
  onChange = _.noop,
}) => {
  return (
    <Accordion
      className={className}
      defaultExpanded={defaultExpanded}
      expanded={expanded}
      sx={customStyles}
      onChange={onChange}
    >
      {isLoading && <Skeleton height={28} variant="text" width="25%" />}
      {!isLoading && !title && <NoAvailableMessageContent delay={100} message="No data." />}
      {!isLoading && title && (
        <AccordionSummary
          aria-controls="panel1-content"
          expandIcon={<ArrowCheckIcon size={IconSize[arrowSize]} />}
          id="panel1-header"
        >
          <Stack className="accordion-summary-container items-center" direction="row" spacing={1.5}>
            <Typography className="accordion-summary-title" variant={titleVariant}>
              {title}
            </Typography>
            {!!labelProps && <LabelCDS {...labelProps} />}
            {!!pendingChangesLabelProps && <LabelCDS {...pendingChangesLabelProps} />}
            {additionalSummaryContent}
          </Stack>
        </AccordionSummary>
      )}
      {!isLoading && !!pendingChangesToggleButtonProps && (
        <SecondaryTabGroupCDS {...pendingChangesToggleButtonProps} />
      )}
      {!isLoading && title && <AccordionDetails>{children}</AccordionDetails>}
    </Accordion>
  );
};

AccordionCDS.propTypes = {
  title: PropTypes.string,
  labelProps: PropTypes.object,
  customStyles: PropTypes.object,
  additionalSummaryContent: PropTypes.node,
  arrowSize: PropTypes.number,
  defaultExpanded: PropTypes.bool,
  expanded: PropTypes.bool,
  titleVariant: PropTypes.string,
  pendingChangesLabelProps: PropTypes.object,
  pendingChangesToggleButtonProps: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func,
  ...WithLoadingPropTypes,
};

export default AccordionCDS;
